import angular from "angular";

angular
    .module('app')
    .component('lessonFormQuiz', {
        template: require('./lesson-form-quiz.html'),
        controller: ['$http', '$uibModal', 'ErrorResponseParser', 'Notifier', '$scope', controller],
        bindings: {
            lesson: '<',
            quiz: '<',
            course: '<',
        }
    });

function controller($http, $uibModal, ErrorResponseParser, Notifier, $scope) {

    let $ctrl = this;

    $ctrl.enabled = false;
    $ctrl.questions = [];

    $ctrl.$onInit = function () {
        $ctrl.quiz = $ctrl.lesson.quiz;
        if ($ctrl.quiz) {
            $ctrl.questions = $ctrl.quiz.questions;
            $ctrl.enabled = $ctrl.quiz.enabled;
        }
    };

    $ctrl.enabledToggle = function (enabled) {
        enabled = !enabled;

        // let per = $ctrl.questions.length > 0;

        // if (per) {
        //     per = enabled;
        // }

        let params = {
            enabled: enabled,
        };

        $http.post(`/admin/courses/${$ctrl.course.id}/lessons/${$ctrl.lesson.id}/quiz/`, params).then(
            function (response) {
                if (response.data) {
                    $ctrl.quiz = response.data;
                }
            }
        );
        return enabled;
    };

    $ctrl.openQuestionForm = function (question) {
        $uibModal
            .open({
                component: 'questionForm',
                resolve: {
                    courseId: function () {
                        return $ctrl.course.id;
                    },
                    lessonId: function () {
                        return $ctrl.course.id;
                    },
                    quizId: function () {
                        return $ctrl.quiz.id;
                    },
                    question: function () {
                        return question;
                    }
                }
            })
        .result
        .then(
            function (resQuestion) {
                if (question) {
                    question.text = resQuestion.text;
                    question.answers = resQuestion.answers;
                } else {
                    $ctrl.questions.push(resQuestion);
                }
            },
        );
    };

    $ctrl.delQuestion = function (question, index) {
        if (!confirm(`Удалить вопрос "${question.text}" ?`)) {
            return;
        }
        $http.delete(`/admin/courses/${$ctrl.course.id}/lessons/${$ctrl.lesson.id}/quiz/${$ctrl.quiz.id}/question/${question.id}`).then(
            function (response) {
                $ctrl.questions.splice(index, 1);
            }
        );
    };
}